import axios from 'axios';

import {
  CASH_DRAWER_SHIFT_SUMMARY,
  CASH_DRAWER_LIST_SHIFT,
  CASH_DRAWER_LIST_SHIFT_V2,
  CASH_DRAWER_EXPORT_SHIFT,
  CASH_DRAWER_SHIFT_DETAILS,
  CASH_DRAWER_LIST_SHIFT_V3,
} from '../constants';

function headersWithOutletId(headers, outletId) {
  if (outletId) {
    return {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      outlet_id: outletId,
      ...headers,
    };
  }
  return headers;
}

export function getSummary(params) {
  const queryParams = {
    page: params.page,
    start: params.start,
    end: params.end,
  };
  return axios
    .get(CASH_DRAWER_SHIFT_SUMMARY, {
      params: queryParams,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { outlet_id: params.outletId },
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getShifts(params) {
  const queryParams = {
    page: params.page,
    start: params.start,
    end: params.end,
  };
  return axios
    .get(CASH_DRAWER_LIST_SHIFT, {
      params: queryParams,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { outlet_id: params.outletId },
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getShiftsV2({ outletId, ...queryParams }) {
  return axios
    .get(CASH_DRAWER_LIST_SHIFT_V2, {
      params: queryParams,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { outlet_id: outletId },
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getShiftsV3({ outletId, ...queryParams }) {
  return axios
    .get(CASH_DRAWER_LIST_SHIFT_V3, {
      params: queryParams,
      headers: { outlet_id: outletId },
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/cash_drawer/shifts_controller.rb#L87
 * @param {object} query
 * @return {Axios.IPromise<U>}
 */
export function exportShift(params) {
  const queryParams = {
    page: params.page,
    start: params.start,
    end: params.end,
    type: params.type,
  };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const headers = { outlet_id: params.outletId };
  return axios
    .get(CASH_DRAWER_EXPORT_SHIFT, {
      params: queryParams,
      headers,
      withCredentials: true,
    })
    .catch((error) => {
      if (error.response) {
        return Promise.reject(new Error(error.response.data.errors));
      }
      return Promise.reject(new Error(error.message));
    });
}

export function getShiftDetails(shiftId, query) {
  const headers = {};
  return axios
    .get(CASH_DRAWER_SHIFT_DETAILS(shiftId), {
      params: query,
      headers: headersWithOutletId(headers, query.outletId),
      withCredentials: true,
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
